import React from 'react';
import { Spinner } from 'react-bootstrap';
import Card from '../../../../components/molecules/cards';
import './style.scss';
import useRoutesRoute from './hooks';
import { DAYS } from '../../../../components/atoms/const';

function RoutesRoute(): React.ReactElement {
  const { isLoading, data, onNavigateToDetail } = useRoutesRoute();

  return (
    <div className="row">
      {/* eslint-disable-next-line no-nested-ternary */}
      {data && data?.data?.data?.length ? (
        data.data.data.map((route: any) => {
          const day = DAYS[route.day];
          const fullName = `${route.user.firstname} ${route.user.lastname}`;
          return (
            <div key={route.id} className="col-sm-12 col-md-6 col-lg-4 col-xl-3 mb-2">
              <Card.Driver
                name={fullName}
                title={route.name}
                day={day}
                id={route.id}
                onClick={() => onNavigateToDetail(route.id)}
              />
            </div>
          );
        })
      ) : isLoading ? (
        <div className="d-flex justify-content-center">
          <Spinner animation="border" />
        </div>
      ) : (
        <div className="text-center">No List</div>
      )}
    </div>
  );
}
export default RoutesRoute;
